<template>
  <div class="AddNewCharteringOrder">
    <SpForm v-model="model" @submit="submit">
      <div class="flex-jc-bt">
        <div class="flex-60">
          <SpTagGroup v-model="model.type">
            <SpTag :label="1">
              <SpPopover trigger="hover">
                <div>{{ $l('TermsTip') }}</div>
                <template #reference>
                  {{ $l('Terms') }}
                </template>
              </SpPopover>
            </SpTag>
            <SpTag :label="2">
              <SpPopover trigger="hover">
                <div>{{ $l('paragraphsTip') }}</div>
                <template #reference>
                  {{ $l('Paragraphs') }}
                </template>
              </SpPopover>
            </SpTag>
            <SpTag :label="3">
              <SpPopover trigger="hover">
                <div>{{ $l('cargoDescriptionTip') }}</div>
                <template #reference>
                  {{ $l('CargoDescription') }}
                </template>
              </SpPopover>
            </SpTag>
            <SpTag :label="4">
              <SpPopover trigger="hover">
                <div>{{ $l('cpTip') }}</div>
                <template #reference>
                  {{ $l('C/P') }}
                </template>
              </SpPopover>
            </SpTag>
          </SpTagGroup>
        </div>
        <div class="flex-38">
          <div class="flex-jc-end">
            <SpButton type="primary" circle="4" class="flex-1" :height="60" html-type="submit">{{ $l('Submit') }}</SpButton>
            <SpButton class="mg-l-20" circle="4" type="back" :width="240" :height="60"><span class="">{{ $L('back') }}</span></SpButton>
          </div>
        </div>
      </div>

      <FullTerms v-show="model.type==1" />
      <SomeRequirementsforChartering v-show="model.type==2" />
      <CargodescriptioninCharteringOrder v-show="model.type==3" />
      <ProformaCP v-show="model.type==4" :data="model" />
    </SpForm>
  </div>
</template>

<script type="text/ecmascript-6">
import SpTagGroup from '@/components/common/SpTagGroup.vue'
import SpTag from '@/components/common/SpTag.vue'
import FullTerms from './FullTerms.vue'
import SpButton from '@/components/common/SpButton.vue'
import SomeRequirementsforChartering from './SomeRequirementsforChartering.vue'
import CargodescriptioninCharteringOrder from './CargodescriptioninCharteringOrder.vue'
import ProformaCP from './ProformaCP.vue'
import { reactive, ref } from 'vue'
import SpForm from '@/components/common/SpForm'
import { cargoTermChartingAddApi, cargoTermChartingDetailApi, getCargoItemApi } from '@/request/APIs/co'
import lodash from 'lodash'
import SpMessage from '@/components/common/SpMessage'
import { useRouter } from 'vue-router'
import SpPopover from '@/components/common/SpPopover'
import useCargoNameOptions from '@/hooks/business/useCargoNameOptions'

export default {
  name: 'AddNewCharteringOrder',

  nameSpace: 'cargoOwner.cargo.CharteringOrder.AddNewCharteringOrder',

  components: {
    SpPopover,
    SpForm,
    SpTagGroup,
    SpTag,
    FullTerms,
    SpButton,
    SomeRequirementsforChartering,
    CargodescriptioninCharteringOrder,
    ProformaCP
  },

  props: {},

  setup (props, ctx) {
    const { cargoNames } = useCargoNameOptions()
    const model = ref({
      type: 1
    })

    const router = useRouter()
    if (router.currentRoute.value.query.id) {
      cargoTermChartingDetailApi(router.currentRoute.value.query.id).then(res => {
        const formatData = {
          type: res.data.type
        }
        formatData[res.data.type] = { ...res.data }
        const effectiveIds = []
        const cIds = cargoNames.value.map(cargo => cargo.value)
        if (formatData[res.data.type].cargoIds.length > 0) {
          formatData[res.data.type].cargoIds.forEach(id => {
            if (cIds.includes(id)) effectiveIds.push(id)
          })
        }
        formatData[res.data.type].cargoIds = effectiveIds
        model.value = formatData
      })
    }

    const submit = (formData) => {
      const compFormData = {
        type: model.value.type,
        ...formData.data[model.value.type]
      }
      if (model.value.type === 4) {
        const files = lodash.flatten(formData.fields.value.filter(item => item.name.startsWith('file')).map(n => n.model.fileList.value))
        compFormData.content = files.map(file => file.file)
      }
      cargoTermChartingAddApi(compFormData).then(res => {
        if (res.code === 1) {
          SpMessage.success('add succeed!')
        }
      }).catch(e => {
        // if (e.data.code === -2) {
        //   SpMessage.error(e.data.data.filter(n => n).join('\n'))
        // }
      })
    }
    return {
      model,
      submit,
      cargoNames
    }
  }
}
</script>

<style scoped lang="less">
.AddNewCharteringOrder {
  padding: @gap;

  .submit {
    margin: @gap*6 0;
  }
}
</style>
